if (!customElements.get('woodvibe-shelf-plan')) {
  customElements.define('woodvibe-shelf-plan', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const dialog = this.querySelector('dialog');
      const open = this.querySelector('[data-shelf-plan-open]');
      this.dataset.ready = '';
      this.addEventListener('click', event => {
        if (event.target.closest('[data-shelf-plan-open]')) {
          this.querySelector('[data-shelf-plan-zoom]').replaceChildren(this.querySelector('[data-shelf-plan]').cloneNode(true));
          dialog.showModal();
        }
        if (event.target.closest('[data-shelf-plan-close]')) dialog.close();
      }, {signal: this.controller.signal});
      dialog.addEventListener('close', () => open.focus(), {signal: this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelector('dialog')?.close();
      delete this.dataset.ready;
    }
  });
}
